import { Menu as BaseMenu } from '@base-ui-components/react/menu'

export const MenuTrigger = BaseMenu.Trigger

export namespace MenuTrigger {
  export interface Props extends BaseMenu.Trigger.Props {}
}
